import * as React from "react"
import type { SVGProps } from "react"
const SvgClicks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M9.16 9.6a4 4 0 0 1 2.82-1.18 4 4 0 0 1 2.08.56 4 4 0 0 1 1.47 1.56q.2.4.6.58a1 1 0 0 0 .8 0 1 1 0 0 0 .5-.5.8.8 0 0 0 .02-.7 5.7 5.7 0 0 0-2.2-2.56 6 6 0 0 0-3.27-.94q-2.49 0-4.24 1.75A5.8 5.8 0 0 0 6 12.41q0 1.75.94 3.22a6 6 0 0 0 2.5 2.23.7.7 0 0 0 .7 0q.36-.18.53-.53a1 1 0 0 0 .01-.78 1 1 0 0 0-.56-.59 4 4 0 0 1-1.56-1.47A4 4 0 0 1 8 12.4q0-1.64 1.17-2.82" />
    <path d="M6.32 6.75a7.7 7.7 0 0 1 5.66-2.32q3.08 0 5.3 2.13a8.4 8.4 0 0 1 2.62 5.13q.05.42.38.73.34.3.76.27.43-.03.72-.31a.8.8 0 0 0 .23-.69 9.6 9.6 0 0 0-3.18-6.59 9.8 9.8 0 0 0-6.83-2.67 10 10 0 0 0-3.89.79 10 10 0 0 0-3.17 2.13 10 10 0 0 0-2.13 3.17 10 10 0 0 0-.79 3.9 10 10 0 0 0 .71 3.7 10 10 0 0 0 1.97 3.12 10 10 0 0 0 2.95 2.21 9 9 0 0 0 3.63.98 1 1 0 0 0 .71-.25 1 1 0 0 0 .31-.7 1 1 0 0 0-.28-.75 1.2 1.2 0 0 0-.74-.38 7.8 7.8 0 0 1-5.2-2.54A7.7 7.7 0 0 1 4 12.4q0-3.35 2.32-5.66" />
    <path d="M13.03 13.97a1 1 0 0 0 0 .39l.62 2.06q.7 2.28 1.36 4.56c.17.58 1.01.59 1.2 0l.58-1.8 1.13 1.14 1.82 1.83a1 1 0 0 0 1.4-.01l.57-.57a1 1 0 0 0 .01-1.4l-1.8-1.78-1.12-1.12 1.86-.65c.57-.19.54-1-.03-1.17a334 334 0 0 1-6.7-2 1 1 0 0 0-.4.01 1 1 0 0 0-.31.19 1 1 0 0 0-.19.32" />
  </svg>
)
export default SvgClicks
